import script from "./goRinSyo0070.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0070.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0070.vue?vue&type=style&index=0&id=4554cb03&lang=scss"

const __exports__ = script;

export default __exports__